module.exports = __webpack_public_path__ + "static/forcestartingstyle-45171267bf017a7f53102d8666b99271.png";